import React from 'react';
import { Wahlkarte } from './Wahlkarte';
import './App.css';
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

function App() {
  return (
	<Wahlkarte />
  );
}

export default App;